import angular from "angular";

export class LocalStorageService {
    static componentName = "localStorageService";

    setItem<T>(name: string, item: T) {
        return localStorage.setItem(name, JSON.stringify(item));
    }

    getItem(name: string, defaultValue = null) {
        const storageValue = localStorage.getItem(name);
        if (storageValue == null) {
            return defaultValue;
        }

        try {
            return JSON.parse(storageValue);
        } catch (error) {
            return defaultValue;
        }
    }

    removeItem(name: string) {
        return localStorage.removeItem(name);
    }
}

angular.module("topline.modules").factory(LocalStorageService.componentName, [LocalStorageService]);
